import { Box, Divider, Typography } from "@mui/material";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { icons } from "../../icons/iconExport";
import TextIntegrationStyle from "../TextIntegrationStyle";

const CategorizedPermissionsDisplay = ({
  readPermissions = [],
  writePermissions = [],
  maxWidth = 550,
}) => {
  const hasReadPermissions = readPermissions.length > 0;
  const hasWritePermissions = writePermissions.length > 0;

  if (!hasReadPermissions && !hasWritePermissions) {
    return null;
  }

  return (
    <Box display={"flex"} flexDirection={"column"} gap={1}>
      <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={1}>
        <SvgToIcon IconLogo={icons.permissionsBoundaryIcon} width={"16px"} />
        <Typography variant={"subtitle2"}>Permissions</Typography>
      </Box>
      <Box
        display={"flex"}
        flexDirection={"row"}
        maxHeight={100}
        maxWidth={maxWidth}
        overflow="auto"
      >
        {hasWritePermissions && (
          <Box flex={1} display={"flex"} flexDirection={"column"} gap={1}>
            <Typography variant={"overline"} ml={3}>
              Write
            </Typography>
            <Box
              display={"flex"}
              flexDirection={"column"}
              gap={1}
              maxHeight={100}
              overflow="auto"
              ml={2}
            >
              {writePermissions.map((permission) => (
                <TextIntegrationStyle
                  key={permission}
                  title={""}
                  value={permission}
                />
              ))}
            </Box>
          </Box>
        )}
        {hasWritePermissions && hasReadPermissions && (
          <Divider orientation="vertical" flexItem />
        )}
        {hasReadPermissions && (
          <Box flex={1} display={"flex"} flexDirection={"column"} gap={1}>
            <Typography variant={"overline"} ml={3}>
              Read
            </Typography>
            <Box
              display={"flex"}
              flexDirection={"column"}
              gap={1}
              maxHeight={100}
              overflow="auto"
              ml={2}
            >
              {readPermissions.map((permission) => (
                <TextIntegrationStyle
                  key={permission}
                  title={""}
                  value={permission}
                />
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default CategorizedPermissionsDisplay;
